import { useEffect } from "react";

export function useKeyboardFix() {
  useEffect(() => {
    if (!window.visualViewport) return;

    const onResize = () => {
      const viewportHeight = window.visualViewport.height;
      const screenHeight = window.innerHeight;

      const keyboardHeight = screenHeight - viewportHeight;

      if (keyboardHeight > 150) {
        document.body.classList.add("keyboard-open");
        document.body.style.paddingBottom = keyboardHeight + "px";
      } else {
        document.body.classList.remove("keyboard-open");
        document.body.style.paddingBottom = "0px";
      }
    };

    window.visualViewport.addEventListener("resize", onResize);
    return () => window.visualViewport.removeEventListener("resize", onResize);
  }, []);
}